var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12V7.21997",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22V19",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22V7.21997",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1001 5.29999C10.1001 5.78999 9.90007 6.25001 9.57007 6.57001C9.25007 6.90001 8.80005 7.09998 8.30005 7.09998H6.05005C6.33005 6.72998 6.50006 6.25 6.50006 5.75V4.84998C6.50006 4.34998 6.33005 3.87 6.05005 3.5H8.30005C9.29005 3.5 10.1001 4.30999 10.1001 5.29999Z",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.84996V5.74999C6.5 6.24999 6.32999 6.72996 6.04999 7.09996C5.28999 8.10996 3.73 8.44996 2.28 7.15996C2.12 7.01996 2 6.71999 2 6.49999V4.15996C2 3.96996 2.10001 3.68997 2.23001 3.54997C3.49001 2.22997 5.01 2.41999 5.84 3.24999C5.91 3.31999 5.97999 3.39998 6.04999 3.48998C6.32999 3.86998 6.5 4.34996 6.5 4.84996Z",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8999 5.29999C13.8999 5.78999 14.0999 6.25001 14.4299 6.57001C14.7499 6.90001 15.1999 7.09998 15.6999 7.09998H17.9499C17.6699 6.72998 17.4999 6.25 17.4999 5.75V4.84998C17.4999 4.34998 17.6699 3.87 17.9499 3.5H15.6999C14.7099 3.5 13.8999 4.30999 13.8999 5.29999Z",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.84996V5.74999C17.5 6.24999 17.67 6.72996 17.95 7.09996C18.71 8.10996 20.27 8.44996 21.72 7.15996C21.88 7.01996 22 6.71999 22 6.49999V4.15996C22 3.96996 21.9 3.68997 21.77 3.54997C20.51 2.22997 18.99 2.41999 18.16 3.24999C18.09 3.31999 18.02 3.39998 17.95 3.48998C17.67 3.86998 17.5 4.34996 17.5 4.84996Z",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5V17.5C10 18.33 9.33 19 8.5 19C7.67 19 7 18.33 7 17.5V13.5C7 12.67 7.67 12 8.5 12C9.33 12 10 12.67 10 13.5Z",
    stroke: "#6D4BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.84e0472014233f440c8d426fc155e4d7.svg";
export { ForwardRef as ReactComponent };